const ITEMS = [
  "Functional skincare",
  "Built skintifically",
  "Lived unapologetically",
  "One Skin",
];

const Marquee = () => {
  const strip = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative z-10 overflow-hidden border-y border-[#3D6B55]/15 py-5 select-none"
    >
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {strip.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span
                  className={
                    item === "Built skintifically"
                      ? "font-script text-3xl md:text-4xl text-[#8B1A2A] px-6"
                      : "font-heading text-lg md:text-xl tracking-[0.2em] uppercase text-[#3D6B55] px-6"
                  }
                >
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-[#E8B4A0]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
